import React,{useState} from 'react';
import {Grid,Avatar,Typography,Paper,Button,Container} from '@material-ui/core';
import useStyles from './styles';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Input from './Input';
import {GoogleLogin} from '@react-oauth/google';
import jwt_decode from 'jwt-decode';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {signup,signin} from '../../actions/auth';

const Auth = () => {
 const [showPassword,setShowPassword] = useState(false);
 const classes = useStyles();
 const initialState={
    firstName:'',
    lastName:'',
    email:'',
    password:'',
    confirmPassword:''
 };
 const [formdata,setFormData]=useState(initialState);
 const [isSignUp,setisSignUp]=useState(false);
 const dispatch = useDispatch();
 const navigate = useNavigate();


const handleSubmit = (e) => {
    e.preventDefault();
   
    if(isSignUp){

        dispatch(signup(formdata,navigate))

    }

    else{

        dispatch(signin(formdata,navigate))

    }
 }

 const handleChange = (e) => {

    setFormData({...formdata ,[e.target.name] : e.target.value})

 }

 const handleShowPassword = () => setShowPassword((prevShowPassword)=> !prevShowPassword);

 const switchMode = () => {
    setisSignUp((previsSignUp)=> !previsSignUp);
    setShowPassword(false);
    
 }

 const handleSuccess = async (res) => {
        const result = jwt_decode(res?.credential)
        
        const token  = res?.credential;

        try {

            dispatch({type:"AUTH",data:{result,token}})
            navigate('/');
            
        } catch (error) {
            console.log(error);
        }
 }

 const handleError = (error) => {

        console.log(error)
 }

  return (
   <Container component="main" maxWidth="xs">
    <Paper className={classes.paper} elevation={3}>
        <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
        </Avatar>
        <Typography variant='h5'>{isSignUp?'Sign Up' :'Sign In'}</Typography>
        <form className={classes.from} onSubmit={handleSubmit}>

                <Grid container spacing={2}>

                    {
                        isSignUp && (
                            <>
                                <Input name="firstName" label="First Name" handleChange={handleChange} autoFocus half />
                                <Input name="lastName" label="Last Name" handleChange={handleChange} half />

                            </>
                        )
                    }
                    <Input name="email" label="Email Address" handleChange={handleChange} type="email" />
                    <Input name="password" label="Password" handleChange={handleChange} type={showPassword?"text":"password"} handleShowPassword={handleShowPassword} />
                    {
                        isSignUp && <Input name="confirmPassword" label="Repeat Password" handleChange={handleChange} type="password" />

                    }
                </Grid>
                
                <Button type="submit" fullWidth variant='contained' color='primary' className={classes.submit}>{isSignUp ? 'Sign Up' : 'Sign In'}</Button>
                <GoogleLogin shape="pill" onSuccess={handleSuccess} onError={handleError}/>
                <Grid container justifyContent='flex-end'>
                    <Grid item>
                            <Button onClick={switchMode}>
                                {isSignUp ? 'Already have an account ? Sign In' : 'Sign Up'}
                            </Button>
                    </Grid>
                </Grid>
        </form>
    </Paper>

   </Container>
  )
}

export default Auth